import Vue from 'vue'

import Icon from './Icon.vue'
import SectionTitle from './SectionTitle.vue'
import SectionSubtitle from './SectionSubtitle.vue'

Vue.component('Icon', Icon)
Vue.component('SectionTitle', SectionTitle)
Vue.component('SectionSubtitle', SectionSubtitle)
